<script>
	//svelte native
	import { onMount } from 'svelte';
	// Components
	//import ComponentIntroText from "../components/ComponentIntroText.svelte";
	//import ComponentIntroTextWithCTA from "../components/ComponentIntroTextWithCTA.svelte";
	//import ComponentLatestMaps from "../components/ComponentLatestMaps.svelte";
	//import ComponentMapList from "../components/ComponentMapList.svelte";
	//import ComponentMapThumb from "../components/ComponentMapThumb.svelte";
	import ComponentParaOne from "../components/ComponentParaOne.svelte";
	import ComponentPlainTextWithCTALarge from "../components/ComponentPlainTextWithCTALarge.svelte";
	//import ComponentPlainTextWithCTASmall from "../components/ComponentPlainTextWithCTASmall.svelte";
	import ComponentPlainTextWithImage from "../components/ComponentPlainTextWithImage.svelte";
	//import ComponentPlainTextWithPromo from "../components/ComponentPlainTextWithPromo.svelte";
	//import Visualisation from "../components/Visualisation.svelte";
	import ComponentBannerFour from "../components/ComponentBannerFour.svelte";
	import ComponentFeatureOne from "../components/ComponentFeatureOne.svelte";
	import ComponentFeatureThreeC from "../components/ComponentFeatureThreeC.svelte";

	import ComponentPlainTextWithImageFirst from "../components/ComponentPlainTextWithImageFirst.svelte";
	import ComponentQuote from "../components/ComponentQuote.svelte";
	import ComponetListSearch from "../components/ComponentListSearch.svelte";


	// modules
	import {fetchPageData} from "../modules/fetchPageData.js";
	import {selectWhere} from "../modules/selectWhere.js";
	import {ficDeMenu} from "../modules/ficMenu.js";

	const comps = [
		{"ComponentParaOne--bp": ComponentParaOne },
		{"ComponentPlainTextWithCTALarge--bp": ComponentPlainTextWithCTALarge},
		{"ComponentPlainTextWithImage--bp": ComponentPlainTextWithImage},
		{"ComponentPlainTextWithImageFirst--bp": ComponentPlainTextWithImageFirst},
		{"ComponentBannerFour--bp": ComponentBannerFour},
		{"ComponentFeatureOne--bp": ComponentFeatureOne},
		{"ComponentFeatureThree--bp": ComponentFeatureThreeC},
		{"ComponentQuote--bp": ComponentQuote},
		{"ComponentListSearch": ComponetListSearch}
	];
	
	//
	let elements =[];

	let pageContent;
	//
	//Quick body tag hack
	let outBod = document.getElementById("outerBody");
	outBod.classList.add("default");
	outBod.classList.remove("map");
	//
	// end  hack :)
	//

	onMount(async  () =>{
	    pageContent = await fetchPageData("page-elements","test");
	    // console.log("pageContent",pageContent);
	    pageContent.forEach(element => elements.push(element));

	    // sort the array on  locationonpage
	    elements.sort(function(a, b) {
	  		var keyA = a.locationOnPage,
	    	keyB = b.locationOnPage;
	  // Compare the 2 
	  		if (keyA < keyB) return -1;
	  		if (keyA > keyB) return 1;
	  		return 0;
		});

	    ficDeMenu();
	});
</script>
<div>
	{#if pageContent}

		{#each elements as body}
		<!-- {console.log("elements: ",elements )} -->
			{#each comps as comp}
			<!-- {console.log("elements.length() = ", elements.length)} -->
			<!-- {console.log("body: ",body)} -->
			<!-- {console.log("body.svelte_component.name: ",body.svelte_component.sveltename)} -->
			<!-- {console.log("comps[body.svelte_component.sveltename ] : ",comps[body.svelte_component.sveltename ])} -->
			<!-- {console.log("comps[body.svelte_component.sveltename ]: ",comps[body.svelte_component.sveltename ])} -->
			<!-- {console.log("comp[body.svelte_component.name ] : ",comp[body.svelte_component.name ] )} -->
				{#if  comp.hasOwnProperty( body.svelte_component.sveltename) }
				<!-- {console.log("body: ", body)} -->

					<svelte:component 
					this = { comp[body.svelte_component.sveltename] } 
					pageCopy={body.Copy}  
					pageTitle={body.Title}  
					buttonLink={body.ButtonLink} 
					buttonText={body.ButtonLabel}
					pageImage={body.Image}
					
					/>
				{:else}
				{/if}

			{/each}
		{/each}


	{:else  }	
	...
	{/if}
</div>




